import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { blogArticles } from '../mockData';
import { ChevronRight } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import SEO from '../components/SEO';

const HolyWord = () => {
  const { t } = useLanguage();
  
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white pt-24 pb-16">
      <SEO title="Holy Word — Scripture, Prayers & Reflections from Jerusalem" description="Explore inspiring scripture, prayers, and reflections about faith, the Holy Land, and prayer at the Church of the Holy Sepulchre, Western Wall, and other sacred sites in Jerusalem." path="/holy-word" />
      {/* Hero Section */}
      <div className="container mx-auto px-4 mb-16">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            {t('nav.holyWord')}
          </h1>
          <p className="text-xl text-gray-600">
            {t('testimonials.subtitle')}
          </p>
        </div>
      </div>

      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {blogArticles.map((article) => (
            <Card key={article.id} className="overflow-hidden hover:shadow-xl transition-all duration-300 group">
              {/* Article Image */}
              <div className="relative h-48 overflow-hidden">
                <img 
                  src={article.image} 
                  alt={article.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                  decoding="async"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
                <div className="absolute top-4 left-4">
                  <span className="px-3 py-1 bg-amber-500 text-white rounded-full text-xs font-medium">
                    {article.category}
                  </span>
                </div>
              </div>
              <CardContent className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3 leading-tight line-clamp-2">{article.title}</h3>
                <p className="text-gray-600 mb-4 leading-relaxed text-sm line-clamp-2">{article.excerpt}</p>
                <Link to={`/article/${article.id}`}>
                  <Button variant="link" className="text-amber-600 hover:text-amber-700 p-0 text-base">
                    {t('testimonials.readMore')} <ChevronRight className="ml-1" size={18} />
                  </Button>
                </Link>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HolyWord;